import { device } from 'app/ui-components/breakpoints';
import {
    iconInfoFilled,
    iconWarningFilled,
    colorPlayYellow2,
    extraLightCoolGrey,
    iconClose,
    regularWhite,
    playGrey15,
    fontWeightBold,
    regularBlack,
} from 'app/ui-components/design-tokens';
import { playFontIcon, playFontSize } from 'app/ui-components/typography/helpers';
import { PlayTextStyles } from 'app/ui-components/typography/PlayText/PlayText.styles';
import { playFocus, VisuallyHidden } from 'app/ui-components/utils.styles';
import styled, { css } from 'styled-components';
import { ContainerBase } from '../../ui-components/PlayContainer/PlayContainer.styles';
import LinkExternal from '../Link/ExternalLink';
import { StyledExternalIcon } from '../Link/Link.styles';

export const StyledImportantMessage = styled.div`
    ${ContainerBase}
    display: flex;
`;

export const StyledImportantMessagesContainer = styled.div`
    flex: 0 0 auto;
    background-color: ${regularBlack};
`;

export const StyledImportantMessageContainer = styled.div`
    ${PlayTextStyles};
    box-sizing: border-box;
    position: relative;
    z-index: 20;
    padding: 15px 0 12px 0;
    margin-bottom: 3px;
    line-height: 1.5;

    @media ${device.GteLarge} {
        padding-left: 0;
        padding-right: 0;
    }

    &:last-child {
        margin-bottom: 0;
    }

    @media print {
        display: none !important;
    }

    ${(props) =>
        props.messageType &&
        css`
            background-color: ${playGrey15};
            color: ${regularWhite};
        `}
`;

export const ImportantMessageIcon = styled.span`
    ${playFontIcon(1.7)}

    vertical-align: middle;
    flex-shrink: 0; /* fixes safari bug */
    margin: 0;
    margin-right: 10px;

    @media ${device.GteSmall} {
        vertical-align: bottom;
    }

    ${(props) =>
        props.iconType === 'VMA' &&
        css`
            &:after {
                color: ${colorPlayYellow2};
                content: '${iconWarningFilled}';
            }
        `}

    ${(props) =>
        props.iconType === 'TMA' &&
        css`
            &:after {
                color: ${extraLightCoolGrey};
                content: '${iconInfoFilled}';
            }
        `}
        

    @media ${device.GteSmall} {
        font-size: 2.2em;
    }

    @media ${device.GteLarge} {
        font-size: 2.5em;
        margin-left: 0;
        margin-top: 1px;
    }
`;

export const StyledImportantMessageCloseIcon = styled.span`
    ${playFontIcon(2.2)}
    &:after {
        content: '${iconClose}';
    }
`;

export const StyledImportantMessageTextContainer = styled.span`
    position: relative;
    display: flex;
    top: -1px;
    flex-grow: 1;
`;

export const StyledImportantMessageText = styled.span`
    display: block;
    align-self: center;
`;

export const StyledImportantMessageLink = styled(LinkExternal)`
    font-weight: ${fontWeightBold};
    display: flex;
    line-height: 1;
    align-items: center;

    @media ${device.GteSmall} {
        display: inline-block;

        & ${StyledExternalIcon} {
            vertical-align: bottom;
        }
    }
`;

export const StyledImportantMessageCloseButton = styled.button`
    ${playFontSize(2)}
    background: none;
    line-height: 0;
    border: none;
    color: ${regularWhite};

    padding: 0 0 20px 10px;
    float: right;
    height: 0;

    ${playFocus()}
`;

export const StyledImportantMessageVisuallyHidden = styled.span`
    ${VisuallyHidden}
`;
